export default function WhiteButtonWithBorder({ text, onClick, size }: any) {
  let px = "px-3";
  let py = "py-2";
  let textSize = "text-base";

  switch (size) {
    case "sm":
      px = "px-2.5";
      py = "py-1.5";
      textSize = "text-sm";
      break;

    case "lg":
      px = "px-4";
      py = "py-2";
      break;

    default:
      break;
  }

  return (
    <>
      <button
        type="button"
        className={`inline-flex items-center justify-center ${px} ${py} border border-gray-300 shadow-sm ${textSize} focus:outline-none rounded bg-white font-medium text-gray-700 hover:bg-gray-50 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}
        onClick={onClick}
      >
        {text}
      </button>
    </>
  );
}
